import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useDropzone } from "react-dropzone";
import { FilePlus, File, XCircle } from "react-feather";
// import AreaMap from "../../../components/AreaMap";
// import InputErrorMessage from "../../../components/InputErrorMessage";
import { formatFileName } from "../../../utils/format";
import { useEffect } from "react";

const AoiUpload = ({ aoiInfo, setAoiInfo, setError }) => {
  const { formatMessage } = useIntl();
  // const [aoiError, setAoiError] = useState(null);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [fileName, setFileName] = useState(null);

  const handleFileChange = async files => {
    setUploadingFile(true);

    if (files.length === 0) {
      return;
    }

    if ((aoiInfo ?? []).length + files.length === 1) {
      setFileName(formatFileName(files[0].name));
    } else {
      setFileName(formatMessage({ id: "multiplos-arquivos" }));
    }

    const filesContents = [];
    for (let file of files) {
      const formData = new FormData();
      formData.set("file_contents", file);

      filesContents.push({
        formData,
        fileName: file.name
      });
    }

    setAoiInfo(oldAoiInfo => [...(oldAoiInfo ?? []), ...filesContents]);
    setUploadingFile(false);
  };

  const { getRootProps, getInputProps } = useDropzone({
    multiple: true,
    onDrop: handleFileChange
  });

  useEffect(() => {
    if (!aoiInfo) {
      setFileName(null);
    }
  }, [aoiInfo]);

  return (
    <>
      {/* {aoiInfo ? (
        // <AreaMap aoiInfo={aoiInfo} id="report-file" className="map" />
      ) : ( */}
      <div
        id="report-file"
        {...getRootProps({
          className:
            "label" +
            (fileName || uploadingFile ? " selected" : "") +
            (false ? " error" : "")
        })}
      >
        {uploadingFile ? (
          <>
            <div className="loader"></div>
            {fileName && `${formatMessage({ id: "Enviando" })} "${fileName}"`}
          </>
        ) : (
          <>
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              {...getInputProps()}
            />
            {fileName ? (
              <>
                {false ? (
                  <XCircle className="file-icon" />
                ) : (
                  <File className="file-icon" />
                )}
                {fileName}
              </>
            ) : (
              <>
                <FilePlus className="file-icon" />
                {formatMessage({ id: "adicionar-arquivo" })}
              </>
            )}
          </>
        )}
      </div>
      {/* )} */}
      {/* {aoiError && <InputErrorMessage message={aoiError} />} */}
    </>
  );
};

export default AoiUpload;
